import { useNavigate } from "react-router-dom";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import { TableItemId } from "../../../../components/tables/TableWidget";
import { receptionRoutes } from "../../../../router/routesConstants";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../components/actionMenu/ActionMenu";

interface NrcdTableActionButtonProps {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  showViewButton?: boolean;
  showEditButton?: boolean;
  showDeleteButton?: boolean;
}

function NrcdTableActionButton({ crudData }: NrcdTableActionButtonProps) {
  return (
    <div className="text-right">
      <ActionButtons
        neconformitati={crudData.neconformitati ?? []}
        crudData={crudData}
      />
    </div>
  );
}

const ActionButtons = ({
  crudData,
}: {
  neconformitati: {
    idType: number;
    type: string;
    cantitate: number;
    status: number;
    reasons: any[];
  }[];
  crudData: any;
}) => {
  const navigate = useNavigate();

  const quarantineProduct = () => {
    navigate(
      `/${receptionRoutes.reception}/${receptionRoutes.quarantine}?reception=${crudData.idFluxReceptie}`,
    );
  };

  const hasNonconformities = crudData.neconformitati?.length > 0;
  const items: ActionMenuItem[] = [
    {
      id: "view-nonconformities",
      label: "Vezi neconformitati",
      icon: "QUARANTINE",
      tooltip: hasNonconformities
        ? "Deschide neconformitatile receptiei acestui produs."
        : "Nu exista neconformitati inregistrate pentru acest produs.",
      disabled: !hasNonconformities,
      onClick: quarantineProduct,
    },
  ];
  return (
    <ActionMenu
      items={items}
      minItemsForMenu={2}
      title={crudData.numeProdus}
      ariaLabel="Actiuni pentru produsul din NIR"
    />
  );
};

export default NrcdTableActionButton;
